module.exports = __webpack_public_path__ + "bradavice_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_2_before.jpg
// module id = 932
// module chunks = 0